export default class BinancePublicClient {
  constructor({ baseURL = "https://fapi.binance.com" } = {}) {
    this.baseURL = baseURL
  }

  // ========= 工具 =========

  _buildQuery(params = {}) {
    return new URLSearchParams(params).toString()
  }

  async _request(path, method = "GET", params = {}) {
    const query = this._buildQuery(params)
    const url = this.baseURL + path + (query ? "?" + query : "")

    try {
      const response = await fetch(url, { method })
      const data = await response.json()

      // ✅ Binance 业务错误优先
      if (typeof data.code !== "undefined" && data.code < 0) {
        const error = new Error(data.msg || `API Error ${data.code}`)
        error.code = data.code
        error.data = data
        throw error
      }

      // ⚠️ HTTP错误（仅提示）
      if (!response.ok) {
        console.warn("HTTP not OK:", response.status, data)
      }

      return data
    } catch (error) {
      console.error("Public request failed:", error.message || error)
      throw error
    }
  }

  // ========= 公共接口 =========

  // 获取市场交易对信息
  exchangeInfo() {
    return this._request("/fapi/v1/exchangeInfo")
  }

  // 获取标记价格和资金费率
  fundingRate(symbol) {
    return this._request("/fapi/v1/premiumIndex", "GET", { symbol })
  }


  // K线
  klines(symbol, interval = "1m", limit = 500) {
    return this._request("/fapi/v1/klines", "GET", {
      symbol,
      interval,
      limit
    })
  }

  // 最新价格
  tickerPrice(symbol) {
    return this._request("/fapi/v1/ticker/price", "GET", { symbol })
  }

  // 24小时统计
  ticker24hr(symbol) {
    return this._request("/fapi/v1/ticker/24hr", "GET", { symbol })
  }

  // 深度
  depth(symbol, limit = 100) {
    return this._request("/fapi/v1/depth", "GET", {
      symbol,
      limit
    })
  }

  // 最近成交
  trades(symbol, limit = 500) {
    return this._request("/fapi/v1/trades", "GET", {
      symbol,
      limit
    })
  }

  // 历史成交
  historicalTrades(symbol, limit = 500) {
    return this._request("/fapi/v1/historicalTrades", "GET", {
      symbol,
      limit
    })
  }

  // 标记价格K线
  markPriceKlines(symbol, interval = "1m", limit = 500) {
    return this._request("/fapi/v1/markPriceKlines", "GET", {
      symbol,
      interval,
      limit
    })
  }

  // 资金费率历史
  fundingRateHistory(symbol, limit = 100) {
    return this._request("/fapi/v1/fundingRate", "GET", {
      symbol,
      limit
    })
  }

  // 持仓多空比（全市场）
  globalLongShortAccountRatio(symbol, period = "5m", limit = 30) {
    return this._request("/futures/data/globalLongShortAccountRatio", "GET", {
      symbol,
      period,
      limit
    })
  }

  // 大户多空比
  topLongShortAccountRatio(symbol, period = "5m", limit = 30) {
    return this._request("/futures/data/topLongShortAccountRatio", "GET", {
      symbol,
      period,
      limit
    })
  }
}